import { render, staticRenderFns } from "./AddressManagement.vue?vue&type=template&id=50546438"
import script from "./AddressManagement.vue?vue&type=script&lang=js"
export * from "./AddressManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports